export const DEFAULT_MENU_CLASS_NAME = '';
export const DEFAULT_MENU_ITEM_CLASS_NAME = '';
